/**
 * Un plan: lo que un cliente tiene contratado de un módulo (una fila de
 * adm_venta vista desde Planes y desde Plataforma).
 */
export class Plan {
  /** adm_venta.id; texto porque así está en la base. Vacío = alta. */
  id: string | null = null;
  /** Corporativo dueño del plan. Lo manda la plataforma; el cliente no lo elige. */
  idCliente: number | null = null;
  /** Nombre del sitio en adm_sitio: el módulo que el plan habilita. */
  sitio: string | null = null;
  cantidadUsuarios: number | null = null;
  /**
   * Personas que ya ocupan una licencia: quien tiene un perfil vigente del
   * módulo y, en Asistencia, también quien tiene modalidad asignada.
   */
  usuariosAsignados = 0;
  /** yyyy-MM-dd al enviar; yyyy-MM-dd HH:mm:ss al recibir. */
  vigencia: string | null = null;
  vigente = false;
}

/** Módulo del catálogo que un cliente aún puede contratar. */
export class ModuloDisponible {
  id: number;
  nombre: string;
  idProducto: number | null;
  nivel: number | null;
}

/** Un cliente de la plataforma: corporativo, empresas y planes. */
export class Cliente {
  idCorporativo: number;
  nombre: string;
  correo: string | null;
  telefono: string | null;
  usuariosActivos = 0;
  empresas: EmpresaResumen[] = [];
  planes: Plan[] = [];
}

export class EmpresaResumen {
  id: number;
  razonSocial: string;
  rfc: string | null;
  status: string | null;
}

/** Lo que la plataforma manda para dar de alta un cliente completo. */
export class ClienteNuevo {
  nombreCorporativo = "";
  telefono: string | null = null;
  correo: string | null = null;
  representanteLegal: string | null = null;
  razonSocial = "";
  rfc: string | null = null;
  usuario = "";
  password = "";
  nombre = "";
  apellidoPaterno = "";
  apellidoMaterno: string | null = null;
  correoAdministrador = "";
  planes: Plan[] = [];
}
